import {Commande} from "../../../model/Commande";
import {
    ContainerDeliveryStatusConstants,
    CovenantDeliveryStatusConstants,
    DeliveryStatusConstants,
    TractionDeliveryStatusConstants,
    TransportationTypeConstants
} from "../../../constants/model";
import React from "react";
import {OverlayTrigger} from "react-bootstrap";

const orderTypeContainerStatuses = Object.entries(ContainerDeliveryStatusConstants).map(([, value]) => value);
const orderTypeCovenentStatuses = Object.entries(CovenantDeliveryStatusConstants).map(([, value]) => value);
const orderTypeTractionStatuses = Object.entries(TractionDeliveryStatusConstants).map(([, value]) => value);

function getStatusList(order: Commande): DeliveryStatusConstants[] {
    if (order.type === "Export" && order.transportType === TransportationTypeConstants.COVENANT) {
        return orderTypeCovenentStatuses.filter(el => el !== CovenantDeliveryStatusConstants.LOADING_ORDER_SENT);
    }

    switch (order.transportType) {
        case TransportationTypeConstants.COVENANT:
            return orderTypeCovenentStatuses;
        case TransportationTypeConstants.TRACTION:
            return orderTypeTractionStatuses;
        case TransportationTypeConstants.CONTAINER:
            return orderTypeContainerStatuses;
        default:
            return [];
    }
}

function getStatusLabel(order: Commande, status: DeliveryStatusConstants): string {
    if (order.type === 'Export') {
        switch (order.transportType) {
            case TransportationTypeConstants.CONTAINER:
                switch (status) {
                    case ContainerDeliveryStatusConstants.DELIVERY_DONE: {
                        return 'Avis positionnement effectué';
                    }
                    default:
                        return status;
                }
            case TransportationTypeConstants.TRACTION:
                switch (status) {
                    case TractionDeliveryStatusConstants.UNLOADING_ORDER_SENT: {
                        return 'Commande d’empotage effectuée';
                    }
                    default:
                        return status;
                }
            case TransportationTypeConstants.COVENANT:
                switch (status) {
                    case TractionDeliveryStatusConstants.DELIVERY_DONE: {
                        return 'Avis enlèvement effectué';
                    }
                    default:
                        return status;
                }
            default:
                return status;
        }
    }

    return status;
}

const ShippingProgressBar = ({order}: {order: Commande}) => {

    const statusList = getStatusList(order);

    const isStatusPending = (index: number) => {
        // @ts-ignore
        return index > statusList.indexOf(order.statusWorkflow);
    };

    return statusList
        .map((status, index) => {
            const bg = isStatusPending(index)
                ? 'bg-danger'
                : 'bg-success';

            return (
                <OverlayTrigger
                    placement="bottom"
                    overlay={<span className={'bg-light px-2 py-1 border'}>{getStatusLabel(order, status)}</span>}
                    key={'status-bar-' + index}
                >
                    <div
                        style={{
                            width: '56px',
                            height: '14px',
                            marginRight: '0.1rem',
                            cursor: 'pointer',
                        }}
                        className={`p-0 ${bg}`}
                    >
                        {
                            status === ContainerDeliveryStatusConstants.TRANSPORT_ORDER_SENT
                                ? (
                                    <span className="text-black" style={{fontSize: 10, position: 'relative', top: -3, left: 3}}>
                                        cde
                                    </span>
                                ) : null
                        }
                    </div>
                </OverlayTrigger>
            );
        });
};

export default ShippingProgressBar